import { Configuration, RedirectRequest } from '@azure/msal-browser'

const entraClientId = import.meta.env.VITE_ENTRA_CLIENT_ID || 'your-client-id'
const entraTenantId = import.meta.env.VITE_ENTRA_TENANT_ID || 'your-tenant-id'

export const msalConfig: Configuration = {
  auth: {
    clientId: entraClientId,
    authority: `https://login.microsoftonline.com/${entraTenantId}`,
    redirectUri: `${window.location.origin}/acquisition/playbook`,
    postLogoutRedirectUri: `${window.location.origin}/acquisition/playbook`,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: import.meta.env.DEV ? 3 : 0,
      piiLoggingEnabled: false,
    },
  },
}

export const loginRequest: RedirectRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    `api://${entraClientId}/user_impersonation`,
  ],
  prompt: 'select_account',
}

export const graphScopes = {
  scopes: ['User.Read'],
}
